// src/sentry.js
import * as Sentry from "@sentry/react";

const DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://96f9c31fdaa8daaca889630e611cbb31@o4509850981892096.ingest.de.sentry.io/4509850983792720";

Sentry.init({
  dsn: DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, // in Prod eher z.B. 0.2
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1, // 10% Sessions aufnehmen
  replaysOnErrorSampleRate: 1.0, // 100% wenn Fehler
  enableLogs: true,
});
